import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
import { brandInfo } from '../mock';
import { Link } from 'react-router-dom';

export const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand Info */}
          <div>
            <h3 className="text-xl font-bold text-red-500 mb-4">{brandInfo.name}</h3>
            <p className="text-gray-300 text-sm mb-4">
              Providing 24/7 emergency and critical care ambulance services with advanced life support equipment and trained paramedics.
            </p>
            <div className="flex items-center space-x-2 text-sm text-gray-400">
              <Phone className="w-4 h-4 text-red-500" />
              <span>Available 24/7</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-red-500 transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-red-500 transition-colors text-sm">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/gallery" className="text-gray-300 hover:text-red-500 transition-colors text-sm">
                  Gallery
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Information</h4>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />
                <div className="text-sm">
                  <a href={`tel:${brandInfo.phones[0]}`} className="text-gray-300 hover:text-red-500 transition-colors block">
                    {brandInfo.phones[0]}
                  </a>
                  <a href={`tel:${brandInfo.phones[1]}`} className="text-gray-300 hover:text-red-500 transition-colors block">
                    {brandInfo.phones[1]}
                  </a>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />
                <a href={`mailto:${brandInfo.email}`} className="text-gray-300 hover:text-red-500 transition-colors text-sm break-all">
                  {brandInfo.email}
                </a>
              </div>
              <div className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />
                <p className="text-gray-300 text-sm">{brandInfo.address}</p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} {brandInfo.name}. All rights reserved. | Emergency Services Available 24/7
          </p>
        </div>
      </div>
    </footer>
  );
};